import React, { Component } from 'react'
import { connect } from 'react-redux'
import Ink from 'react-ink';
import PropTypes from 'prop-types'

class UserListItem extends Component {
  constructor(props) {
    super(props);
    this.handleUserListItem = this.handleUserListItem.bind(this);
  }

  handleUserListItem() {
    this.props.onClick(this.props);
  }

  render() {
    let html = '';
    if (this.props.UserName === '') {
      html = (<button className="userlistitem" disabled>
      &nbsp;
      </button>)
    } else {
      html = (<button className="userlistitem" onClick={this.handleUserListItem}>
        {this.props.UserName}
        <Ink />
        </button>)
    }
    return (html)
  }
}
UserListItem.propTypes = {
  UserName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}

function mapStateToProps() {
  return {
  }
}

export default connect(mapStateToProps)(UserListItem);



// WEBPACK FOOTER //
// src/login/UserListItem.jsx